const ImageIlustrationPaymentes = () => {
    return (
        <img
            src='/assets/ilustrations/payments.svg'
            style={{ width: "100%", height: "150px", marginBottom: "16px" }}
        />
    );
}

export default ImageIlustrationPaymentes;